import React from 'react';
import { useLanguage, LANGUAGES } from '../../context/LanguageContext';
import './LanguageSelector.css';

function LanguageSelector({ variant = 'default' }) {
    const { language, setLanguage, supportedLanguages } = useLanguage();

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
    };

    // Compact inline switcher - just shows language codes as pills
    return (
        <div className={`language-switcher ${variant}`}>
            {supportedLanguages.map(lang => {
                const langInfo = LANGUAGES[lang] || { short: lang.toUpperCase() };
                const isActive = language === lang;
                return (
                    <button
                        key={lang}
                        className={`lang-pill ${isActive ? 'active' : ''}`}
                        onClick={() => handleLanguageChange(lang)}
                        aria-label={langInfo.name || lang}
                        title={langInfo.name || lang}
                    >
                        {langInfo.short}
                    </button>
                );
            })}
        </div>
    );
}

export default LanguageSelector;
